import {
  Box,
  Grid,
  GridItem,
  Image,
  Button,
  IconButton,
  Checkbox,
  Text,
  Divider,
} from "@chakra-ui/react";
import { useState } from "react";
import { BaseInput } from "../components/Base/BaseInput";
import { BaseText } from "../components/Base/BaseText";
import MakerKidsLogo from "../mk_logo_new.png";

import { ReactComponent as LogoApple } from "../assets/img/logo-apple.svg";
import { ReactComponent as LogoGoogle } from "../assets/img/logo-google.svg";

const LoginPage = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [user, setUser] = useState({
    email: "",
    password: "",
    remember: false,
  });

  const onSetUser = (pUser: Partial<typeof user>) => {
    setUser((user) => ({
      ...user,
      ...pUser,
    }));
  };

  return (
    <Grid templateColumns={{ base: "repeat(1, 1fr)", lg: "repeat(2, 1fr)" }}>
      <GridItem bg={{ base: "#F9F9F9", lg: "white" }}>
        <Box
          maxW={{ base: "auto", lg: "424px" }}
          mx={{ base: 0, lg: "auto" }}
          bg={{ base: "white", lg: "transparent" }}
          mt={{ base: 0, lg: "191px" }}
          height={{ base: "74px", lg: "auto" }}
          display={{ base: "flex", lg: "block" }}
          alignItems="center"
          justifyContent="center"
        >
          <Image
            height={10}
            src={MakerKidsLogo}
            alt="MakerKids Logo"
            style={{ marginLeft: "-4px" }}
          />
        </Box>

        <Box maxW="424px" mx="auto" px={{ base: 8, lg: 0 }}>
          <BaseText
            mt={{ base: "64px", lg: "30px" }}
            font={["Cairo", 700, "28px", "35px"]}
          >
            Login
          </BaseText>
          <BaseText
            mt={"10px"}
            color="#A5A5A5"
            font={["Open Sans", 400, "18px", "15px"]}
          >
            Log In with Your MakerKids Account
          </BaseText>

          <Box mt="6">
            <BaseInput
              type="email"
              name="email"
              label="Email Address"
              placeholder="username@email.com"
            />

            <BaseInput
              mt="4"
              name="password"
              label="Password"
              placeholder="•••••••••••••••"
              type={isPasswordVisible ? "text" : "password"}
              rightElement={
                <IconButton
                  border="none"
                  bg="transparent"
                  fontSize="20px"
                  color="#9CA3AF"
                  aria-label="View Passowrd"
                  icon={
                    <i
                      className={
                        isPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"
                      }
                    />
                  }
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                />
              }
            />

            <Box
              mt="4"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Checkbox
                isChecked={user.remember}
                onChange={(e) => onSetUser({ remember: e.target.checked })}
              >
                <BaseText color="#374151" font={["Inter", 400, "sm", "20px"]}>
                  Keep me logged in
                </BaseText>
              </Checkbox>
              <button>
                <BaseText color="#23428D" font={["Inter", 400, "sm", "20px"]}>
                  Forgot Password?
                </BaseText>
              </button>
            </Box>

            <Button
              mt="6"
              h={"44px"}
              width={"full"}
              rounded="12px"
              fontSize={"sm"}
              border={"none"}
              display={"block"}
              fontFamily="Cairo"
              colorScheme={"blue"}
              bg="#23428D"
              _hover={{ bg: "#1D2B7E" }}
              boxShadow={"0px 1px 2px rgba(31, 41, 55, 0.08)"}
            >
              Login
            </Button>

            <Box mt="2" textAlign="center" position="relative">
              <Divider
                left="0"
                right="0"
                borderColor={"#9CA3AF"}
                position="absolute"
                top="12px"
                zIndex={1}
              />
              <BaseText
                color="#9CA3AF"
                px="3"
                bg="white"
                zIndex={2}
                display="inline"
                position="relative"
                font={["Inter", 500, "sm", "20px"]}
              >
                or use following
              </BaseText>
            </Box>

            <Box display="flex" mt="2" experimental_spaceX={2}>
              <Button
                flex={1}
                bg="white"
                border="1px solid #E5E7EB"
                borderRadius="12px"
                h="44px"
                fontFamily="Cairo"
                fontWeight="700"
                fontSize="sm"
                lineHeight="20px"
                boxShadow="0px 1px 2px rgba(31, 41, 55, 0.08)"
              >
                <LogoGoogle height="20px" width="20px" />
                <Text ml="2">Log in with Google</Text>
              </Button>
              <Button
                flex={1}
                bg="white"
                border="1px solid #E5E7EB"
                borderRadius="12px"
                h="44px"
                fontFamily="Cairo"
                fontWeight="700"
                fontSize="sm"
                lineHeight="20px"
                boxShadow="0px 1px 2px rgba(31, 41, 55, 0.08)"
              >
                <LogoApple height="18px" width="18px" />
                <Text ml="2">Log in with Apple</Text>
              </Button>
            </Box>

            <BaseText
              mt="6"
              color="#374151"
              font={["Inter", 400, "sm", "20px"]}
            >
              Not a member?{" "}
              <button style={{ color: "#23428D" }}>Sign up</button>
            </BaseText>
          </Box>
        </Box>
      </GridItem>
      <GridItem display={{ base: "none", lg: "block" }}>
        <Image
          height={"100vh"}
          objectFit={"cover"}
          objectPosition={"center"}
          alt="Child reading on laptop at library"
          src="https://images.unsplash.com/photo-1584697964358-3e14ca57658b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
        />
      </GridItem>
    </Grid>
  );
};

export { LoginPage };
